"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.list = exports.localState = undefined;
exports.reducer = reducer;

var _reselect = require("reselect");

var _decimal = require("../../../decimal");

var _decimal2 = _interopRequireDefault(_decimal);

var _util = require("../../util");

var Util = _interopRequireWildcard(_util);

var _data = require("./data");

var _data2 = _interopRequireDefault(_data);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _data2.default;

  return state;
}

var localState = exports.localState = function localState(state) {
  return state.entities2.achievementTypes;
};
var list = exports.list = (0, _reselect.createSelector)(localState, function (s) {
  return s.list;
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZW50aXRpZXMyL2FjaGlldmVtZW50LXR5cGVzL3Jvb3QuanMiXSwibmFtZXMiOlsicmVkdWNlciIsIlV0aWwiLCJzdGF0ZSIsImxvY2FsU3RhdGUiLCJlbnRpdGllczIiLCJhY2hpZXZlbWVudFR5cGVzIiwibGlzdCIsInMiXSwibWFwcGluZ3MiOiI7Ozs7OztRQW9CZ0JBLE8sR0FBQUEsTzs7QUFuQmhCOztBQUNBOzs7O0FBQ0E7O0lBQVlDLEk7O0FBQ1o7Ozs7Ozs7O0FBZ0JPLFNBQVNELE9BQVQsR0FBK0M7QUFBQSxNQUE5QkUsS0FBOEI7O0FBQ3BELFNBQU9BLEtBQVA7QUFDRDs7QUFFTSxJQUFNQyxrQ0FBYSxTQUFiQSxVQUFhLENBQUNELEtBQUQ7QUFBQSxTQUN4QkEsTUFBTUUsU0FBTixDQUFnQkMsZ0JBRFE7QUFBQSxDQUFuQjtBQUVBLElBQU1DLHNCQUFPLDhCQUFlSCxVQUFmLEVBQTJCO0FBQUEsU0FBS0ksRUFBRUQsSUFBUDtBQUFBLENBQTNCLENBQWIiLCJmaWxlIjoicm9vdC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5pbXBvcnQge2NyZWF0ZVNlbGVjdG9yfSBmcm9tIFwicmVzZWxlY3RcIlxuaW1wb3J0IERlY2ltYWwgZnJvbSBcIi4uLy4uLy4uL2RlY2ltYWxcIlxuaW1wb3J0ICogYXMgVXRpbCBmcm9tIFwiLi4vLi4vdXRpbFwiXG5pbXBvcnQgc3RhdGUwIGZyb20gXCIuL2RhdGFcIlxuXG5leHBvcnQgdHlwZSBUaHJlc2hWYWx1ZSA9IERlY2ltYWwgfCBudW1iZXIgfCBzdHJpbmdcbmV4cG9ydCB0eXBlIFRocmVzaFNwZWMgPSB7W3N0cmluZ106IFRocmVzaFZhbHVlfVxuXG5leHBvcnQgdHlwZSBFbnRyeSA9IHt8XG4gICtuYW1lOiBzdHJpbmcsXG4gICtwb2ludHM6IG51bWJlcixcbiAgK3Zpc2libGU6IFRocmVzaFNwZWMsXG4gICtjb21wbGV0ZTogVGhyZXNoU3BlYyxcbnx9XG5leHBvcnQgdHlwZSBTdGF0ZSA9IHt8XG4gICtsaXN0OiBBcnJheTxFbnRyeT4sXG4gICtzY2hlbWE6ICRGbG93VE9ETywgLy8gVE9ETyByZW1vdmVcbnx9XG5cbmV4cG9ydCBmdW5jdGlvbiByZWR1Y2VyKHN0YXRlOiBTdGF0ZSA9IHN0YXRlMCk6IFN0YXRlIHtcbiAgcmV0dXJuIHN0YXRlXG59XG5cbmV4cG9ydCBjb25zdCBsb2NhbFN0YXRlID0gKHN0YXRlOiBVdGlsLlJvb3RTdGF0ZSkgPT5cbiAgc3RhdGUuZW50aXRpZXMyLmFjaGlldmVtZW50VHlwZXNcbmV4cG9ydCBjb25zdCBsaXN0ID0gY3JlYXRlU2VsZWN0b3IobG9jYWxTdGF0ZSwgcyA9PiBzLmxpc3QpXG4iXX0=


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/entities2/achievement-types/root.js
// module id = 795
// module chunks = 0